import { Component } from '@angular/core';

@Component({
  selector: 'cards',
  templateUrl: './cards.component.html'
})

export class CardsComponent {
  title = 'Cards';
}



// WEBPACK FOOTER //
// ./src/app/cards.component.ts